export default __webpack_public_path__ + "static/media/BANNER-PAGINA-WEB-AGENDA-2026.69f5fefa.jpeg";